import { useCallback, useEffect, useState } from 'react';
import {
  fetchUnifiedPortalUsers,
  type UnifiedPortalUser,
} from '../lib/portalUnifiedUsers';

export function useUnifiedPortalUserLookup() {
  const [rows, setRows] = useState<UnifiedPortalUser[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;
    void fetchUnifiedPortalUsers()
      .then((list) => {
        if (!cancelled) setRows(list);
      })
      .catch(() => {
        if (!cancelled) setRows([]);
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });
    return () => {
      cancelled = true;
    };
  }, []);

  const displayNameFor = useCallback(
    (email?: string | null) => {
      const trimmed = email?.trim();
      if (!trimmed) return null;
      const row = rows.find(
        (entry) => entry.email.toLowerCase() === trimmed.toLowerCase(),
      );
      return row?.displayName?.trim() || null;
    },
    [rows],
  );

  return { rows, loading, displayNameFor };
}
